module.exports = __webpack_public_path__ + "img/debatePresi20193.2c206b9d.jpg";